<script lang="ts">
  import Metrics from './metrics.svelte';

  import type { GetProductQuery } from '$gql/storefront/operations';
  import type { MetricsByVariantStoryblok } from '$types/bloks';

  let className: string | undefined = undefined;
  export { className as class };
  export let block: MetricsByVariantStoryblok;
  export let selectedProductVariant:
    | NonNullable<GetProductQuery['product']>['variants']['nodes'][number]
    | undefined = undefined;
</script>

{#if selectedProductVariant && selectedProductVariant?.sku === block.variant_sku}
  <Metrics {block} class={className} />
{/if}
